import Papa from 'papaparse';

const PREFIX = 'exreg.import.v2';
const read = key => {
  try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch { return null; }
};
const write = (key, value) => localStorage.setItem(key, JSON.stringify(value));
export const defaultImportOptions = () => ({ dateFormat: 'auto', valueMappings: {}, resolutions: {} });
export const importScope = (user, apiBase) => JSON.stringify([apiBase || '', user?.id ?? user?.username ?? 'unknown', user?.database_name ?? 'unknown']);
export const profileStorageKey = scope => `${PREFIX}.profiles.${scope}`;
export const readImportProfiles = scope => read(profileStorageKey(scope)) || {};
export const saveImportProfile = (scope, name, mapping, options) => {
  const profiles = readImportProfiles(scope);
  const next = { ...profiles, [name]: { mapping, options: { dateFormat: options.dateFormat, valueMappings: options.valueMappings || {} } } };
  write(profileStorageKey(scope), next);
  return next;
};
export const removeImportProfile = (scope, name) => {
  const profiles = { ...readImportProfiles(scope) };
  delete profiles[name];
  write(profileStorageKey(scope), profiles);
  return profiles;
};
export const readImportDraft = (scope, fileKey) => read(`${PREFIX}.draft.${scope}.${fileKey}`);
export const saveImportDraft = (scope, fileKey, mapping, options) => write(`${PREFIX}.draft.${scope}.${fileKey}`, { mapping, options });
export const fingerprintImport = async value => {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  const hash = await window.crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(hash), byte => byte.toString(16).padStart(2, '0')).join('');
};
export const filterImportMapping = (mapping, headers, availableFields) => Object.fromEntries(
  Object.entries(mapping || {}).filter(([field, column]) => availableFields.includes(field) && headers.includes(column))
);
export const makeImportReport = (review, snapshot, exceptionsOnly = false) => {
  const outcomes = new Map((snapshot?.outcomes || []).map(outcome => [outcome.index, outcome]));
  return review.entries.flatMap(entry => {
    const outcome = outcomes.get(entry.index);
    const status = outcome?.status || entry.status;
    if (exceptionsOnly && ['imported', 'ready'].includes(status)) return [];
    return [{
      ...Object.fromEntries(Object.entries(entry.source).map(([column, value]) => [column, value?.__importCellError ? value.originalText : value])),
      'EXREG source row': entry.rowNumber,
      'EXREG status': status,
      'EXREG reason': outcome?.reason || entry.issues.map(issue => issue.message).join(' | '),
      'EXREG decisions': JSON.stringify(outcome?.decisions || entry.decisions || []),
      'EXREG mapped values': JSON.stringify(outcome?.values || entry.values),
    }];
  });
};
export const downloadImportCsv = (rows, name) => {
  const blob = new Blob(['\ufeff', Papa.unparse(rows, { escapeFormulae: true })], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url; link.download = name;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
